module.exports = __webpack_public_path__ + "static/media/COS_MOLNLYCKE.2be251ec.png";